import { EndpointBuilder } from '@reduxjs/toolkit/dist/query/endpointDefinitions';

export default (build: EndpointBuilder<any, any, any>) =>
  build.mutation<any, Body>({
    query: (body) => ({
      url: `v4/pitch-owner/tournaments/${body.tournamentId}/custom/schedule/clear`,
      method: 'POST',
    }),
  });

interface Body {
  tournamentId: number;
}
